import { Field, useField, useFormikContext } from "formik";
import React, { FC, useState } from "react";
import ErrorMessage from "../ErrorMessage";
import "./Select.css";
import Select, {
  GroupedOptionsType,
  OptionsType,
  OptionTypeBase,
} from "react-select";

export interface IInput
  extends React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  name: string;
  icon?: string;
  fullWidth?: boolean;
  errMsg?: string;
  onChangeVal?: (val: any) => void;
  options: GroupedOptionsType<OptionTypeBase> | OptionsType<OptionTypeBase>;
}

export function useFieldToTextField({
  disabled,
  name,
  onChangeVal,
  ...props
}: IInput) {
  const [touched, setTouched] = useState<boolean>(false);

  const { isSubmitting, setFieldValue, submitCount } = useFormikContext();
  const fieldProps = useField(name);

  const [field, meta] = fieldProps;

  const fieldError = meta.error;
  let showError =
    (touched && !!fieldError) || submitCount > 0 || props.errMsg !== undefined;

  const findOptionValue = props.options.find((x) => x.value === field.value);

  return {
    ...props,
    value: (findOptionValue && findOptionValue[0]) || undefined,
    caption: showError ? fieldError || props.errMsg : "",
    status: showError ? "danger" : "",
    showError,
    onBlur: () => {
      setTouched(true);
    },
    onChange: (event: any) => {
      setFieldValue(name, event.value);
      if (onChangeVal) {
        onChangeVal(event.value);
      }
    },
    helperText: showError ? fieldError : null,
    disabled: disabled || isSubmitting,
  };
}

const SelectInput: FC<IInput> = (props) => {
  const textField = useFieldToTextField(props);
  const { isSubmitting } = useFormikContext();

  const [fieldSelectValue, setFieldSelectValue] = useState<any>(undefined);

  return (
    <Field name={props.name}>
      {() => (
        <>
          <div className="select-icons">
            {props.icon && (
              <img alt="Input icon" src={props.icon} className="icon" />
            )}

            <Select
              id="color"
              className={`select-field ${isSubmitting ? " disabled" : ""} ${
                props.fullWidth ? "full-width-select" : ""
              } ${!props.icon ? "nopaddingleft" : ""} ${
                !props.icon && props.fullWidth ? "noIconFullWidth" : ""
              }`}
              placeholder={textField.placeholder}
              options={textField.options}
              onChange={(event) => {
                setFieldSelectValue(event);
                textField.onChange(event);
              }}
              onBlur={textField.onBlur}
              value={fieldSelectValue}
            />
            <ErrorMessage {...textField} />
          </div>
        </>
      )}
    </Field>
  );
};

export default SelectInput;
